// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemList_wrapper__1jSVd"};